"use client"
import { API_SUBMIT_ENDPOINT_URL, HOST_URL } from "@/libs/constants"
import { Utils } from "@/libs/Utils"
import { usePathname } from "next/navigation"
import React from "react"
import { Col, Form } from "react-bootstrap"
import LayoutForm from "../LayoutForm"
import PhoneNumber from "./private/PhoneNumber"
interface PostFormProps {
    locale: string
    block?: any
}

const PostForm: React.FunctionComponent<PostFormProps> = ({ locale }) => {
    const t = new Utils(locale).Translation
    const pathname = usePathname()
    const [submited, updateSubmited] = React.useState<boolean>(false)
    // const [gtag, initializeGtag] = React.useState<any>(null)

    const handleSubmit = async (values: any) => {
        const { firstname, lastname, email, company, department, title, country, phone, content } = values;

        const data: any = {
            firstname: firstname?.value,
            lastname: lastname?.value,
            email: email?.value,
            company: company?.value,
            department: department?.value,
            title: title?.value,
            country: country?.value,
            phone: phone?.value,
            content: content?.value,
            tracking: `${HOST_URL}${pathname}`
        }

        const body = Object.keys(data).filter((k) => !!data[k]).map((k: string) => {
            if (data[k] && !!data[k] && data[k] !== "undefined")
                return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
        })

        let response = await fetch(`${API_SUBMIT_ENDPOINT_URL}/submit`, {
            method: 'POST',
            body: body.join('&'),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        });
        const { status } = await response.json()

        let gtag = undefined
        if (typeof window !== 'undefined') {
            gtag = (window as any)?.gtag
        }
        if (gtag && status === 200) {
            gtag('event', 'generate_lead', {
                method: 'BlogForm'
            });
        }
        return status
    }

    return (
        <LayoutForm submited={submited} locale={locale} callback={handleSubmit} updateSubmited={updateSubmited}>
            <Form.Group as={Col} md={12} xs={12} className="mb-3">
                <PhoneNumber locale={locale} />
                <Form.Label>{t("form.contact.content")} <span className="text-danger">*</span></Form.Label>
                <Form.Control required type="text" as="textarea" name="content" />
                <Form.Control.Feedback type="invalid">[{t("form.contact.content")}] {t("required.message")}</Form.Control.Feedback>
            </Form.Group>
        </LayoutForm>
    )
}

export default PostForm